export const POLL_INTERVAL_MS = 4000;

export const RUN_STATUS_LABELS: Record<string, string> = {
	queued: 'В очереди',
	running: 'Выполняется',
	completed: 'Завершён',
	completed_empty: 'Пустая сессия',
	completed_with_warnings: 'Завершён с предупреждениями',
	failed: 'Ошибка',
	cancelled: 'Отменён',
};

export const TERMINAL_STATUSES = new Set([
	'completed',
	'completed_empty',
	'completed_with_warnings',
	'failed',
	'cancelled',
]);
